export function shouldShowMenu(routePath: string, isAuthenticated: boolean): boolean {
  return isAuthenticated && routePath !== '/login'
}
